module.exports = __webpack_public_path__ + "static/hackathon-logo-drawing-b9bf46291d7bca0c33bcda429b7fd79f.jpeg";